import React, { useEffect, useState } from "react";
import drumAudio from "./audio/ultra-long-90second-drumroll_ceremony-23168.mp3";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const BirthdayPopup = () => {
  const [popupMessages, setPopupMessages] = useState([]);
  const [hasShownToday, setHasShownToday] = useState(false);
  const [img, setImg] = useState("");
  const [employees, setEmpData] = useState([]);
  const [confettiItems, setConfettiItems] = useState([]);

  useEffect(() => {
    performRequest("GET", `/employeeManagement/getAllEmplopyeeData`)
      .then((res) => {
        if (res.status === 200) {
          setEmpData(res.data.employeeManagement);
        } else {
          Toast("error", "Error while getting employees!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const getISTTime = () => {
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istOffset = 5.5 * 60 * 60000;
    return new Date(utc + istOffset);
  };

  const startCelebration = (audioSrc, durationSec) => {
    let sound = new Audio(audioSrc);
    sound.loop = true;
    sound
      .play()
      .then(() => console.log("Playing sound"))
      .catch((err) => console.warn("Audio play failed:", err));

    createConfetti();

    setTimeout(() => {
      sound.pause();
      sound.currentTime = 0;
      setConfettiItems([]);
      document.getElementById("open-popup-modal").click(); // hide modal
      setPopupMessages([]);
    }, durationSec * 1000);
  };

  // const createConfetti = () => {
  //   const colors = ["#e91e63", "#3f51b5", "#ff9800", "#4caf50"];
  //   const confetti = [];
  //   for (let i = 0; i < 60; i++) {
  //     confetti.push({
  //       id: i,
  //       left: Math.random() * 100, // percentage
  //       color: colors[Math.floor(Math.random() * colors.length)],
  //       delay: Math.random() * 2,
  //     });
  //   }
  //   setConfettiItems(confetti);
  // };

  const createConfetti = () => {
    const colors = ["#e91e63", "#3f51b5", "#ff9800", "#4caf50"];
    const confetti = [];
    for (let i = 0; i < 100; i++) {
      confetti.push({
        id: Date.now() + Math.random(),
        left: Math.random() * 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 2,
      });
    }
    setConfettiItems(confetti);
  };

  const startStepByStepConfetti = () => {
    let count = 0;
    const maxSteps = 6;

    const step = () => {
      if (count < maxSteps) {
        createConfetti();
        count++;
        setTimeout(step, 5000); // wait 2 sec before next burst
      } else {
        setConfettiItems([]);
      }
    };

    step();
  };

  function getRandomString(arr) {
    if (arr.length === 0) return null; // Handle empty array case
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const istNow = getISTTime();
      const hours = istNow.getHours();
      const minutes = istNow.getMinutes();

      if (
        ((hours === 10 && minutes === 0) ||
          (hours === 12 && minutes === 0) ||
          (hours === 16 && minutes === 0) ||
          (hours === 18 && minutes === 0)) &&
        !hasShownToday
      ) {
        const messages = [];
        let imageUrl = "";
        let audioSrc = drumAudio; // default

        employees.forEach((emp) => {
          const dob = new Date(emp.dateOfBirth);
          const joinDate = new Date(emp.dateOfJoining);
          const yearsCompleted = istNow.getFullYear() - joinDate.getFullYear();

          const isBirthday =
            dob.getDate() === istNow.getDate() &&
            dob.getMonth() === istNow.getMonth();

          const isAnniversary =
            joinDate.getDate() === istNow.getDate() &&
            joinDate.getMonth() === istNow.getMonth() &&
            yearsCompleted >= 1;

          if (isBirthday && isAnniversary) {
            messages.push(
              `🎉 ${emp.firstName} ${emp.lastName} has both a Birthday AND ${yearsCompleted} Year Anniversary today!`
            );

            audioSrc = drumAudio;
            setImg(
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1751950025/Pngtree_happy_work_anniversary_16380132_1_avdsoi.png"
            );
          } else if (isBirthday) {
            messages.push(
              `🎂 Happy Birthday ${emp.firstName} ${emp.lastName}!`
            );
            setImg(
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1751691419/pngtree-happy-birthday-text-effect-png-image_241348_eriuij.png"
            );
            audioSrc =
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751969469/Happy_birthday_to_you_MIDI_chosic.com_zf6pmo.mp3";
          } else if (isAnniversary) {
            messages.push(
              `🎊 ${emp.firstName} ${
                emp.lastName
              } completed ${yearsCompleted} year${
                yearsCompleted > 1 ? "s" : ""
              } today!`
            );
            setImg(
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1751950025/Pngtree_happy_work_anniversary_16380132_1_avdsoi.png"
            );

            const strings = [
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967303/achievement-short-version-170836_lh6x3v.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967296/innovation-and-achievement-corporate-289531_wn7rzl.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967288/successful-cheerful-uplifting-positive-achievement-motivational-music-16529_v1crql.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967283/winning-elevation-111355_bhueaz.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967265/your-achievement-295633_cq2v5v.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967241/achievement-short-version-170836_aebaeo.mp3",
            ];
            audioSrc = getRandomString(strings);
          }
        });

        if (messages.length > 0) {
          setPopupMessages(messages);
          // setImg(imageUrl);
          document.getElementById("open-popup-modal").click();
          startStepByStepConfetti();
          startCelebration(audioSrc, 50);
          setHasShownToday(true);
        }
      }

      if (
        (hours === 0 && minutes === 0) ||
        (hours === 10 && minutes === 30) ||
        (hours === 12 && minutes === 30) ||
        (hours === 16 && minutes === 30) ||
        (hours === 18 && minutes === 30)
      ) {
        setHasShownToday(false);
      }
    }, 1000 * 55);

    return () => clearInterval(interval);
  }, [employees, hasShownToday]);

  return (
    <>
      <button
        id="open-popup-modal"
        data-bs-toggle="modal"
        data-bs-target="#milestone-modal"
        style={{ display: "none" }}
      ></button>

      <div
        className="modal modal-blur fade"
        id="milestone-modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div
            className="modal-content"
            style={{
              background: "#fffafc",
              borderRadius: "15px",
              padding: "20px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              border: "5px solid #ffb6c1",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div className="modal-body">
              <div className="text-center">
                {img && (
                  <img
                    src={img}
                    alt="Celebration"
                    style={{
                      maxHeight: "300px",
                      maxWidth: "90%",
                      width: "auto",
                      marginBottom: "20px",
                    }}
                  />
                )}
                {popupMessages.map((msg, idx) => {
                  let color = "#333";
                  if (msg.includes("Happy Birthday")) color = "#e91e63";
                  else if (msg.includes("completed")) color = "#3f51b5";
                  else if (msg.includes("both a Birthday AND"))
                    color = "#ff9800";

                  return (
                    <div
                      key={idx}
                      style={{
                        fontSize: "4rem",
                        color: color,
                        fontFamily: "cursive",
                        marginBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      <span>{msg}</span>
                    </div>
                  );
                })}
                {/* Render confetti */}
                {confettiItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      position: "absolute",
                      top: "-20px",
                      left: `${item.left}%`,
                      width: "10px",
                      height: "10px",
                      backgroundColor: item.color,
                      borderRadius: "50%",
                      animation: `fall 3s linear ${item.delay}s forwards`,
                    }}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes fall {
            to {
              transform: translateY(600px) rotate(360deg);
              opacity: 0;
            }
          }
        `}
      </style>
    </>
  );
};

export default BirthdayPopup;
